import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import { supabase } from '../supabaseClient';

function EnergyHealing({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'energyHealing',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .energy-healing-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                    }
                    .energy-healing-btn {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 100px !important;
                        padding: 10px 0 !important;
                        font-size: 16px !important;
                    }
                }
                `}
            </style>
            <div style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}>
                {/* Title */}
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginBottom: '32px',
                }}>
                    Energy Movement
                </h3>

                {/* Session Helper Cards Row */}
                <div
                    className="energyhealing-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>• Our intention can direct the energy</div>
                            <div>• Our belief and expectation have to be inline with the intention we have for the energy to move the way we prefer</div>
                            <div>• Anyone can direct energy with intention</div>
                            <div>• It is important to support our bodies with resources when we move energy (like water, rest, time, safety...)</div>
                            <div>• We do not give others our energy, we give others energy information they can match or not</div>
                            <div>• Change will only happen in the direction of your highest good. When working with energy the soul is consulted first</div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. Have you ever given or received energy medicine?</div>
                            <div>2. Everything is Energy</div>
                            <div>3. Our intention can direct the energy</div>
                            <div>4. Our belief and expectation have to be inline with the intention we have for the energy to move the way we prefer</div>
                            <div>5. Anyone can direct energy with intention</div>
                            <div>6. It is important to support our bodies with resources when we move energy (like water, rest, time, safety...)</div>
                        </div>
                    </div>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                }}>
                    {/* Card 1 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'black',
                            textAlign: 'center',
                            lineHeight: '1.5',
                            marginBottom: '16px',
                        }}>
                            Energy healing involves working with the energy systems to promote balance and well-being. Reiki is the practice of using an energy aimed at the body, while quantum energy movement is aimed at moving the energy that is above the body on a higher plane.  I personally have experimented with both of these energy practices and found them worth while.  There are some great methods and teachers out there I will mention.  I will also share my personal experience with Energy movement as a self use tool.   
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Practices such as Reiki, Qi Gong, and chakra balancing can help restore harmony and support wellness. Recently I have seen Dissolve therapy. I know about QHHT, Tapping, Marconics, Body Code, and Quantum modalities as well. Donna Eden has offered a lot of her teachings for free on Youtube. In Donna Eden's work she describes the way that the energy that is in the body can start to move unilaterally instead of bilaterally. When we trace the energy meridians to cross the energy from one side of the body to the other repeatedly along with our intention to do so, we can direct our energy body to sync both hemispheres. Having our hemispheres synced is an important step in changing our beliefs.  Robert Gene also offers information about Faster Eft for free on Youtube. He shows how we can move energy through the meridians while changing the story we have been living and the results are very impressive. <br /> There are many different things to learn about moving energy to assist the body.  Even without intentional energy movement practices the human body is naturally moving energy. We really just need to make sure we are not doing anything to impede that process. We can only help it along where neccessary. <br /> For instance on a physical level if we have a slice in our skin we might flatten it and bandage it while keeping it clean for the healing process to take place.   When we do energy movement we want to make sure we stay hydrated.  We also want to be sure we have the resources our body needs to do the work.  If we get intuitively prompted to take a certain vitamin for instance, we can trust that our self regulating system is trying to get what it needs.Explore different energy movement modalities to find what resonates with you and supports your journey.  
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            I have explored Reiki, Tapping, Energy Medicine by Donna Eden, Marconics, and Quantum energy modalities.  What I ended up doing was just taking a bit of this and that to develop a method that worked for me.  I had been doing some guided meditations that moved energy as well so I even used some of that in the mix.  I believe what I did might be classified as a quantum method. <br />  I learned that it may not be the tool for everyone every time, but despite that it has been fascinating and worthwhile in my life. <br /> First of all, intention is part of the process. I just set my intention to inform the energy of its opportunity to return to blueprint wholeness.  Then I connect my own energy to "heaven and earth".(see the video below for a more specific description)  I expand my heart energy past the constaints of time and space.  Then I pull the energy of myself or the other up to the level of blueprint wholeness. Then I take violet flame energy to brush down the body to remove the density and transmute it.  I ask mother earth to cleanse the energy and return it in the form of rainbow love water. <br /> Now, I know how this might sound to someone who is unfamiliar with energy work, but this is for real.  This really did produce results. On more than one occasion there have been miraculous results.  I will share some personal stories from some of my older Youtube videos below. 
                        </p>
                    </div>
                </div>
                {/* First Embedded Video Card */}
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    margin: '24px 0 0 0'
                }}>
                    <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/qrNViAr39Ss?si=tYvr1Ffdh1pxX2z5"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        style={{
                            borderRadius: '10px',
                            maxWidth: '100%',
                            minHeight: '200px'
                        }}
                    ></iframe>
                </div>
                {/* Second Embedded Video Card */}
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    margin: '24px 0 0 0'
                }}>
                    <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/-n6m6ZOKZjs?si=YKSAH9Aq_NIVc_xu&amp;controls=0"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        style={{
                            borderRadius: '10px',
                            maxWidth: '100%',
                            minHeight: '200px'
                        }}
                    ></iframe>
                </div>
                {/* Navigation Buttons */}
                <div
                    className="energy-healing-btn-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '32px',
                    }}>
                    <button
                        className="energy-healing-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goBack}
                    >Back</button>
                    <button
                        className="energy-healing-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goHome}
                    >Home</button>
                    <button
                        className="energy-healing-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={handleSaveProgress}
                    >Save</button>
                </div>
            </div>
        </>
    );
}

export default EnergyHealing;
